const MAX_SHEET_HEIGHT = 900;
const MOBILE_VIEWPORT_RATIO = 0.92;

export function calculateSheetViewport(
  layoutHeight: number,
  visualHeight: number,
  visualOffsetTop: number,
): { height: number; bottom: number } {
  const safeLayoutHeight = Math.max(0, layoutHeight);
  const safeVisualHeight = Math.max(0, Math.min(visualHeight, safeLayoutHeight));
  const safeOffsetTop = Math.max(0, visualOffsetTop);
  return {
    height: Math.min(safeVisualHeight * MOBILE_VIEWPORT_RATIO, MAX_SHEET_HEIGHT),
    bottom: Math.max(0, safeLayoutHeight - safeOffsetTop - safeVisualHeight),
  };
}
